import { Component, OnInit, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SalesFunnelDataService, Package } from '../shared/sales-funnel-data.service';
import { ISalesFunnelLayoutChild } from '../shared/sales-funnel-child.module';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-package-offer',
  standalone: true,
  imports: [
    FormsModule
  ],
  templateUrl: './package-offer-component.html',
  styleUrls: ['./package-offer-component.scss']
})
export class PackageOfferComponent implements OnInit, ISalesFunnelLayoutChild {
  private router = inject(Router);
  private http = inject(HttpClient);
  private dataService = inject(SalesFunnelDataService);

  private readonly baseUrl: string = environment.dataApiBase;
  private readonly TOKEN_KEY = 'jwtToken';
  packages = signal<Package[]>([]);

  selectedPackage: Package | null = null;
  discount: string | number = '';
  salesFunnelIndex = 1;


  ngOnInit(): void {
    const data = this.dataService.getData();
    const url = `${this.baseUrl}/price-plans`;

    if (data.selectedPackage) {
      this.selectedPackage = data.selectedPackage;
    }
    if (data.discount) {
      this.discount = data.discount;
    }
    const isBusiness = data.lead?.id?.at(-1) || "0";
    console.info(`[PackageOffer] Fetching packages where business=${isBusiness}`);
    const token = localStorage.getItem(this.TOKEN_KEY) || '';
    const headers = new HttpHeaders(
      token ? { Authorization: `Bearer ${token}` } : {}
    );
    this.http.get<Package[]>(`${url}/business/${isBusiness}`, { headers })
      .subscribe(packages => this.packages.set(packages));
  }

  selectPackage(pkg: Package): void {
    this.selectedPackage = pkg;
    this.dataService.updatePackage(pkg);
  }

  goBack(): void {
    this.router.navigate(['/sales-funnel']);
  }

  goToCustomerDetails(): void {
    if (this.selectedPackage) {
      if (this.discount) {
        this.dataService.updateDiscount(Number(this.discount) || 0);
      }
      this.router.navigate(['/customer-details']);
    }
  }
}
